import { render, staticRenderFns } from "./List-edit.vue?vue&type=template&id=135c44ef&scoped=true"
import script from "./List-edit.vue?vue&type=script&lang=js"
export * from "./List-edit.vue?vue&type=script&lang=js"
import style0 from "./List-edit.vue?vue&type=style&index=0&id=135c44ef&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c44ef",
  null
  
)

export default component.exports